module.exports = __webpack_public_path__ + "img/contents_market_mob_main_01.e9187f1.png";